export default {
  loadingScheme: 'Ladeschema',
  partNoPlaceholder: 'Teile-Nr. eingeben',
  noAssetQualificationsMatch: 'Teil "{part}" kann nicht auf Ofen "{asset}" verarbeitet werden.',
  noMatchedRecipeFound: 'Teil "{part}" kann nicht auf Ofen "{asset}" und Rezept "{recipe}" verarbeitet werden.',
  amountDoesNotMatch: 'Maximal Anzahl für Teil "{part}" ist überschritten. Es dürfen "{max}" Teile geladen werden, es wurden aber "{actual}" Teile geladen.',
  totalWeight: 'Gesamtgewicht',
};
